export default __webpack_public_path__ + "static/media/pictogramBeaconCertificateEducation128.84af828c.svg";